var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShopping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8047_8988)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.00004 14.6663C6.36823 14.6663 6.66671 14.3679 6.66671 13.9997C6.66671 13.6315 6.36823 13.333 6.00004 13.333C5.63185 13.333 5.33337 13.6315 5.33337 13.9997C5.33337 14.3679 5.63185 14.6663 6.00004 14.6663Z",
    stroke: "#000000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 14.6663C13.7015 14.6663 14 14.3679 14 13.9997C14 13.6315 13.7015 13.333 13.3333 13.333C12.9651 13.333 12.6666 13.6315 12.6666 13.9997C12.6666 14.3679 12.9651 14.6663 13.3333 14.6663Z",
    stroke: "#000000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.666626 0.666992H3.33329L5.11996 9.59366C5.18092 9.90059 5.3479 10.1763 5.59166 10.3725C5.83541 10.5688 6.14042 10.673 6.45329 10.667H12.9333C13.2462 10.673 13.5512 10.5688 13.7949 10.3725C14.0387 10.1763 14.2057 9.90059 14.2666 9.59366L15.3333 4.00033H3.99996",
    stroke: "#000000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8047_8988"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#000000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopping);
export default __webpack_public_path__ + "static/media/shopping.1be0a317a25f099b3d86595120bf6177.svg";
export { ForwardRef as ReactComponent };